<h2 mat-dialog-title>Modul {{ data?.id ? "bearbeiten" : "anlegen" }}</h2>
<div class="pixl-form">
    <mat-divider></mat-divider>

    <mat-tab-group>
        <mat-tab label="Basisdaten">
            <mat-dialog-content [formGroup]="form" class="grid">
                <mat-form-field class="full-width">
                    <mat-label>Ober-Titel</mat-label>
                    <input matInput formControlName="preTitle" />
                </mat-form-field>


                <mat-form-field class="full-width">
                    <mat-label>Titel</mat-label>
                    <input matInput formControlName="title" />
                </mat-form-field>

                <mat-form-field class="full-width">
                    <mat-label>Beschreibung</mat-label>
                    <input matInput type="text" required placeholder="" formControlName="description" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Anwendung</mat-label>
                    <mat-select formControlName="consumer">
                        @for (consumer of consumers$ | async; track consumer.id) {
                            <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="preview-container border-area full-width">
                    <div class="content">
                        <div>
                            <button class="extend-button" mat-stroked-button (click)="openImageChoice()">
                                <mat-icon>add_photo_alternate</mat-icon>
                                Vorschaubild auswählen
                            </button>
                        </div>

                        @if (getImageName() && getImageName().length > 0) {
                            <div>
                                <div class="media-container">
                                    <div class="media-item">
                                        <div class="media-item">
                                            <img src="{{ imageUrl() }}" alt="" class="preview" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-1">
                                <span class="info cut-long-text">{{ getImageName() }}</span>
                            </div>

                            <div>
                                <button mat-icon-button (click)="deleteMediaEntry()">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        }
                    </div>
                </div>

                @if (isZavAdmin) {
                    <div class="content-array-wrapper border-area full-width">
                        <div formArrayName="content" class="content-array-container">
                            @for (ctrl of contentControls.controls; track $index) {
                                <div class="content-item-row">
                                    <mat-form-field class="content-input">
                                        <input matInput placeholder="Content" [formControlName]="contentControls.controls.indexOf(ctrl)" />
                                    </mat-form-field>

                                    <button
                                            mat-icon-button
                                            color="warn"
                                            type="button"
                                            class="remove-button"
                                            (click)="removeContent(contentControls.controls.indexOf(ctrl))"
                                            aria-label="Remove content item"
                                    >
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            }
                        </div>

                        <div class="add-button-wrapper">
                            <button mat-raised-button color="primary" type="button" (click)="addContent()">
                                <mat-icon>add</mat-icon>
                                Inhalt hinzufügen
                            </button>
                        </div>
                    </div>
                }

                <div class="filter-item">
                    <pixl-state-cb [required]="true" [initValue]="form.get('status')?.value" (onStateChange)="statusChanged($event)" />
                </div>

                <mat-form-field>
                    <mat-label>Fächer/Berufe</mat-label>
                    <mat-select formControlName="subjects" multiple>
                        @for (subject of subjects$ | async; track subject.id) {
                            <mat-option [value]="subject.id">{{ subject.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Schulklassen</mat-label>
                    <mat-select formControlName="schoolClasses" multiple>
                        @for (schoolClass of schoolClasses$ | async; track schoolClass.id) {
                            <mat-option [value]="schoolClass.id">Klasse {{ schoolClass.grade }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="border-area full-width">
                    <div class="multi-select mt-2">
                        <pixl-multi-combo-entity-search
                            [label]="learningUnitLabel"
                            [observable$]="learningUnits$"
                            [namingColumn]="'title'"
                            [externalSearch]="true"
                            (onStateChange)="receiveLearningUnitData($event)"
                            (onSearchChange)="receiveLearningUnitQuery($event)"
                            (scrolledToEnd)="loadMoreLearningUnits($event)"
                            [(selectedValues)]="selectedLearningUnits"
                        >
                        </pixl-multi-combo-entity-search>
                    </div>
                    <div class="mb-1">Anordnen (Drag'n Drop)</div>
                    <div cdkDropList class="order-list" (cdkDropListDropped)="reOrderSelectedLearningUnits($event)">
                        <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
                        <div *ngFor="let learningUnit of selectedLearningUnits; trackBy: trackById" class="order-box" cdkDrag>
                            {{ learningUnit.title }}
                        </div>
                    </div>
                </div>
            </mat-dialog-content>
        </mat-tab>
        <mat-tab [label]="(selectedConsumerName$ | async) || 'Metadaten'">
            <mat-dialog-content class="grid">
                <pixl-object-consumer-metadata [parentForm]="form" [objectType]="'module'"></pixl-object-consumer-metadata>
            </mat-dialog-content>
        </mat-tab>
        @if (isAbuConsumer) {
            <mat-tab label="Kanton & Beruf">
                <mat-dialog-content class="grid">
                    <div class="full-width">
                        <p>Zuordnung von Lerneinheiten zu Kanton und Beruf</p>

                        @for (row of metadataRows; track $index) {
                            <div class="border-area full-width metadata-row">
                                <div class="metadata-row-fields">
                                    <div class="multi-select">
                                        <pixl-multi-combo-entity-search
                                            [label]="getMetadataRowCantonLabel($index)"
                                            [observable$]="metadataRowCantonOptions$[$index]"
                                            [namingColumn]="'label'"
                                            [externalSearch]="true"
                                            (onStateChange)="receiveMetadataRowCantonData($index, $event)"
                                            (onSearchChange)="receiveMetadataRowCantonQuery($index, $event)"
                                            [(selectedValues)]="metadataRowSelectedCantons[$index]"
                                        >
                                        </pixl-multi-combo-entity-search>
                                    </div>

                                    <div class="multi-select">
                                        <pixl-multi-combo-entity-search
                                            [label]="getMetadataRowProfessionLabel($index)"
                                            [observable$]="metadataRowProfessionOptions$[$index]"
                                            [namingColumn]="'label'"
                                            [externalSearch]="true"
                                            (onStateChange)="receiveMetadataRowProfessionData($index, $event)"
                                            (onSearchChange)="receiveMetadataRowProfessionQuery($index, $event)"
                                            [(selectedValues)]="metadataRowSelectedProfessions[$index]"
                                        >
                                        </pixl-multi-combo-entity-search>
                                    </div>

                                    <div class="multi-select">
                                        <pixl-multi-combo-entity-search
                                            [label]="getMetadataRowLearningUnitLabel($index)"
                                            [observable$]="metadataRowLearningUnits$[$index]"
                                            [namingColumn]="'title'"
                                            [externalSearch]="true"
                                            (onStateChange)="receiveMetadataRowLearningUnitData($index, $event)"
                                            (onSearchChange)="receiveMetadataRowLearningUnitQuery($index, $event)"
                                            (scrolledToEnd)="loadMoreMetadataRowLearningUnits($index, $event)"
                                            [(selectedValues)]="metadataRowSelectedLearningUnits[$index]"
                                        >
                                        </pixl-multi-combo-entity-search>
                                    </div>

                                    <button mat-icon-button color="warn" (click)="removeMetadataRow($index)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                                @if (metadataRowSelectedLearningUnits[$index] && metadataRowSelectedLearningUnits[$index].length) {
                                    <div class="metadata-row-order">
                                        <div class="metadata-order-label">Anordnen (Drag'n Drop)</div>
                                        <div cdkDropList class="order-list" (cdkDropListDropped)="reOrderMetadataRowLearningUnits($index, $event)">
                                            <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
                                            <div *ngFor="let learningUnit of metadataRowSelectedLearningUnits[$index]; trackBy: trackById" class="order-box" cdkDrag>
                                                {{ learningUnit.title }}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }

                        <div class="add-button-wrapper mb-3">
                            <button mat-raised-button color="primary" type="button" (click)="addMetadataRow()">
                                <mat-icon>add</mat-icon>
                                Kanton & Beruf hinzufügen
                            </button>
                        </div>
                    </div>
                </mat-dialog-content>
            </mat-tab>
        }
    </mat-tab-group>
    <br />
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Speichern</button>
    </mat-dialog-actions>
</div>
